import React from 'react'
import { tableCellSanitizer } from '@App/helpers/table-cell-sanitizer'
import { formatName } from '@App/helpers/format-name'
import { OriginalPublisherModel } from '@Entities/work/original-publisher-model'
import { ZodFormattedError } from 'zod'
import { observer } from 'mobx-react'

interface PublisherWriterSectionProps {
    isOp: boolean
    originalPub?: OriginalPublisherModel
    originalError?: ZodFormattedError<OriginalPublisherModel>
}

const PublisherWriterSection = ({ isOp, originalPub, originalError }: PublisherWriterSectionProps) => {
    const representedWriters = originalPub?.writers
        .map((writer) => formatName(writer.firstName, writer.lastName, writer.fullName))
        .join(', ')

    const errors = originalPub?.writers
        .flatMap((writer, idx) => [
            ...(originalError?.writers?.[idx]?.firstName?._errors || []),
            ...(originalError?.writers?.[idx]?.lastName?._errors || []),
        ])
        .filter(Boolean)
        .join(', ')

    return (
        <div className="writers">
            {isOp && originalPub && (
                <>
                    <span>{tableCellSanitizer(representedWriters)}</span>
                    <span className="error-field">{errors}</span>
                </>
            )}
        </div>
    )
}

export default observer(PublisherWriterSection)
